var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31429 0C7.98894 0 9.595 0.665253 10.7792 1.84941C11.9633 3.03357 12.6286 4.63963 12.6286 6.31429C12.6286 7.87829 12.0554 9.316 11.1131 10.4234L11.3754 10.6857H12.1429L17 15.5429L15.5429 17L10.6857 12.1429V11.3754L10.4234 11.1131C9.316 12.0554 7.87829 12.6286 6.31429 12.6286C4.63963 12.6286 3.03357 11.9633 1.84941 10.7792C0.665253 9.595 0 7.98894 0 6.31429C0 4.63963 0.665253 3.03357 1.84941 1.84941C3.03357 0.665253 4.63963 0 6.31429 0ZM6.31429 1.94286C3.88571 1.94286 1.94286 3.88571 1.94286 6.31429C1.94286 8.74286 3.88571 10.6857 6.31429 10.6857C8.74286 10.6857 10.6857 8.74286 10.6857 6.31429C10.6857 3.88571 8.74286 1.94286 6.31429 1.94286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0f761cb4a9f03fd70b708a663b6ec8e7.svg";
export { ForwardRef as ReactComponent };